import { formatDate } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { RestService } from '../services/rest.service';
import { StaticElement } from '../services/static.element';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  current_date = formatDate(new Date(), 'yyyy-MM-dd', 'en');

  loading = false;

  filter_period: Array<Object> = [];
  filter_period_current = null;
  filter_period_ini: String = null;
  filter_period_end: String = null;
  filter_group_by: Array<Object> = [];
  filter_group_by_current: String = null;

  //top
  top_views_page = null;
  top_views_article = null;
  top_views_section = null;
  top_views_topic = null;
  top_keyword = null;

  LastSectionTab1 = "Páginas mas vistas";
  LastSectionTab2 = "Páginas mas vistas";

  private color_general = '#07c8f0';
  private color_frontpage = '#ffc107';
  private color_article = '#4caf50';
  private color_section = '#009688';
  private color_topic = '#673ab7';
  private color_other = '#607D88';

  private color_pie_1 = 'rgba(33, 150, 243, 0.5)';
  private color_pie_2 = 'rgba(103, 58, 183, 0.5)';
  private color_pie_3 = 'rgba(244, 67, 54, 0.5)';
  private color_pie_4 = 'rgba(0, 188, 212, 0.5)';
  private color_pie_5 = 'rgba(0, 150, 136, 0.5)';
  private color_pie_6 = 'rgba(255, 235, 59, 0.5)';
  private color_pie_7 = 'rgba(255, 152, 0, 0.5)';
  private color_pie_8 = 'rgba(121, 85, 72, 0.5)';
  private color_pie_9 = 'rgba(96, 125, 139, 0.5)';
  private color_pie_10 = 'rgba(76, 175, 80, 0.5)';

  private colorh_pie_1 = 'rgba(33, 150, 243, 0.8)';
  private colorh_pie_2 = 'rgba(103, 58, 183, 0.8)';
  private colorh_pie_3 = 'rgba(244, 67, 54, 0.8)';
  private colorh_pie_4 = 'rgba(0, 188, 212, 0.8)';
  private colorh_pie_5 = 'rgba(0, 150, 136, 0.8)';
  private colorh_pie_6 = 'rgba(255, 235, 59, 0.8)';
  private colorh_pie_7 = 'rgba(255, 152, 0, 0.8)';
  private colorh_pie_8 = 'rgba(121, 85, 72, 0.8)';
  private colorh_pie_9 = 'rgba(96, 125, 139, 0.8)';
  private colorh_pie_10 = 'rgba(76, 175, 80, 0.8)';

  private pie_options = {
    responsive: true,
    animation: {
      animateScale: true,
      animateRotate: true
    },
    legend: {
      display: false
    },
  };

  pie_background = [
    this.color_pie_1,
    this.color_pie_2,
    this.color_pie_3,
    this.color_pie_4,
    this.color_pie_5,
    this.color_pie_6,
    this.color_pie_7,
    this.color_pie_8,
    this.color_pie_9,
    this.color_pie_10
  ];

  pie_h_background = [
    this.colorh_pie_1,
    this.colorh_pie_2,
    this.colorh_pie_3,
    this.colorh_pie_4,
    this.colorh_pie_5,
    this.colorh_pie_6,
    this.colorh_pie_7,
    this.colorh_pie_8,
    this.colorh_pie_9,
    this.colorh_pie_10
  ];

  private pie_color = [
    {
      backgroundColor: this.pie_background,
      borderColor: this.pie_background,
      hoverBorderColor: this.pie_background,
      hoverBackgroundColor: this.pie_h_background
    }
  ];

  top_views_section_article = null;
  chart_tvsa = null;

  top_views_topic_article = null;
  chart_tvta = null;

  top_realized_event = null;
  chart_tre = null;

  private line_options = {
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true
        }
      }]
    },
    legend: {
      /* display: false */
    },
    /* elements: {
      point: {
        radius: 5,
      }
    } */
  };

  count_view_page = null;
  count_view_page_labels = [];
  count_view_page_dataset_general = null;
  count_view_page_dataset_type_article = null;
  count_view_page_dataset_type_frontpage = null;
  count_view_page_dataset_type_section = null;
  count_view_page_dataset_type_topic = null;
  count_view_page_dataset_type_other = null;

  constructor(private restService: RestService) {
  }

  ngOnInit() {
    this.init_static();
    this.filter_group_by_current = "YYYY-MM-DD";
    this.filter_period_current = 2;
    this.change_filter_period_current();
  }

  init_static(): void {
    //init_period
    this.filter_period = StaticElement.filter_period;
    //filter_group_by
    this.filter_group_by = StaticElement.filter_group_by;
  }

  change_filter_period_current(): void {
    const date_i = new Date();
    const date_f = new Date();
    switch (this.filter_period_current) {
      case 1: //{ id: '1', name: 'Personalizado' },
        this.filter_period_ini = null;
        this.filter_period_end = null;
        break;
      case 2: //{ id: '2', name: 'Hoy' },
        this.filter_period_ini = formatDate(date_i, 'yyyy-MM-dd', 'en');
        this.filter_period_end = formatDate(date_f, 'yyyy-MM-dd', 'en');
        break;
      case 3: //{ id: '3', name: 'Ayer' },
        date_i.setDate(date_i.getDate() - 1);
        this.filter_period_ini = formatDate(date_i, 'yyyy-MM-dd', 'en');
        date_f.setDate(date_f.getDate() - 1);
        this.filter_period_end = formatDate(date_f, 'yyyy-MM-dd', 'en');
        break;
      case 4: //{ id: '4', name: 'La semana pasada' },
        date_i.setDate(date_i.getDate() - (date_i.getDay() + 6));
        this.filter_period_ini = formatDate(date_i, 'yyyy-MM-dd', 'en');
        date_f.setDate(date_f.getDate() - (date_f.getDay()));
        this.filter_period_end = formatDate(date_f, 'yyyy-MM-dd', 'en');
        break;
      case 5: //{ id: '5', name: 'El mes pasado' },
        date_i.setMonth(date_i.getMonth() - 1);
        date_i.setDate(1);
        this.filter_period_ini = formatDate(date_i, 'yyyy-MM-dd', 'en');
        date_f.setMonth(date_f.getMonth());
        date_f.setDate(0);
        this.filter_period_end = formatDate(date_f, 'yyyy-MM-dd', 'en');
        break;
      case 6: //{ id: '6', name: 'Últimos 7 días' },
        date_i.setDate(date_i.getDate() - 7);
        this.filter_period_ini = formatDate(date_i, 'yyyy-MM-dd', 'en');
        date_f.setDate(date_f.getDate() - 1);
        this.filter_period_end = formatDate(date_f, 'yyyy-MM-dd', 'en');
        break;
      case 7: //{ id: '7', name: 'Últimos 30 días' }
        date_i.setDate(date_i.getDate() - 30);
        this.filter_period_ini = formatDate(date_i, 'yyyy-MM-dd', 'en');
        date_f.setDate(date_f.getDate() - 1);
        this.filter_period_end = formatDate(date_f, 'yyyy-MM-dd', 'en');
        break;
    }
    if (this.filter_period_current != 1 && this.filter_period_current != null) {
      this.dashboard_home_get_data();
      // this.tabset1.select("Páginas mas vistas");
      this.clearTables();
      this.onChangeTab2();
      this.onChangeTab1();

    }
  }

  change_filter_period_ini_end(): void {
    if (this.filter_period_ini && this.filter_period_end) {
      this.filter_period_current = 1;
      this.dashboard_home_get_data();
      this.clearTables();
      this.onChangeTab2();
      this.onChangeTab1();
    }
  }

  dashboard_home_get_data() {
    this.loading = true;
    const filters = {
      group_by: this.filter_group_by_current,
      date_ini: this.filter_period_ini,
      date_end: this.filter_period_end
    };
    this.restService.dashboard_home_get_data(filters).subscribe(data => {
      if (data.success) {
        this.set_data(data.data);
        this.loading = true;

      } else {

      }
      this.loading = false;
    }, err => {
      this.loading = false;
    });
  }

  dashboard_home_get_data_top_realized_event() {
    const filters = {
      group_by: this.filter_group_by_current,
      date_ini: this.filter_period_ini,
      date_end: this.filter_period_end
    };
    this.restService.dashboard_home_get_data_top_realized_event(filters).subscribe(data => {
      if (data.success) {
        this.top_realized_event = data.data.top_realized_event || [];
        this.set_chart_chart_tre(this.top_realized_event);
      } else {

      }
      // this.loading = false;
    }, err => {
      // this.loading = false;
    });
  }

  dashboard_home_get_data_top_views_article() {
    const filters = {
      group_by: this.filter_group_by_current,
      date_ini: this.filter_period_ini,
      date_end: this.filter_period_end
    };
    this.restService.dashboard_home_get_data_top_views_article(filters).subscribe(data => {
      if (data.success) {
        this.top_views_article = data.data.top_views_article || [];
      }
    }, err => {
    });
  }

  dashboard_home_get_data_top_views_section() {
    const filters = {
      group_by: this.filter_group_by_current,
      date_ini: this.filter_period_ini,
      date_end: this.filter_period_end
    };
    this.restService.dashboard_home_get_data_top_views_section(filters).subscribe(data => {
      if (data.success) {
        this.top_views_section = data.data.top_views_section || [];
      } else {
      }
    }, err => {
    });
  }

  dashboard_home_get_data_top_views_topic() {
    const filters = {
      group_by: this.filter_group_by_current,
      date_ini: this.filter_period_ini,
      date_end: this.filter_period_end
    };
    this.restService.dashboard_home_get_data_top_views_topic(filters).subscribe(data => {
      if (data.success) {
        this.top_views_topic = data.data.top_views_topic || [];
      }
    }, err => {
    });
  }

  dashboard_home_get_data_top_views_topic_article() {
    const filters = {
      group_by: this.filter_group_by_current,
      date_ini: this.filter_period_ini,
      date_end: this.filter_period_end
    };
    this.restService.dashboard_home_get_data_top_views_topic_article(filters).subscribe(data => {
      if (data.success) {
        this.top_views_topic_article = data.data.top_views_topic_article || [];
        this.set_chart_chart_tvta(this.top_views_topic_article);
      }
    }, err => {
    });
  }

  set_data(_data): void {
    if (_data.top_views_page) this.top_views_page = _data.top_views_page || null;
    if (_data.top_keyword) this.top_keyword = _data.top_keyword || null;

    if (_data.count_view_page) {
      this.init_chart_count_view_page(_data.count_view_page);
      this.set_chart_count_view_page();
    }

    if (_data.top_views_section_article) {
      this.top_views_section_article = _data.top_views_section_article || null;
      this.set_chart_chart_tvsa(this.top_views_section_article);
    }
  }

  set_chart_chart_tvsa(_data): void {
    if (_data == null || _data.length == 0) {
      this.chart_tvsa = null;
      return;
    }
    const pie_labels = [];
    const pie_data = [];
    _data.forEach(element => {
      pie_labels.push(element?.section);
      pie_data.push(element?.count);
    });

    this.chart_tvsa = {
      datasets: [{
        label: '# of vistas',
        data: pie_data
      }],
      labels: pie_labels,
      options: this.pie_options,
      colors: this.pie_color
    };
  }

  set_chart_chart_tvta(_data): void {
    if (_data == null || _data.length == 0) {
      this.chart_tvta = null;
      return;
    }
    const pie_labels = [];
    const pie_data = [];
    _data.forEach(element => {
      pie_labels.push(element?.topic);
      pie_data.push(element?.count);
    });

    this.chart_tvta = {
      datasets: [{
        label: '# of vistas',
        data: pie_data
      }],
      labels: pie_labels,
      options: this.pie_options,
      colors: this.pie_color
    };
  }

  set_chart_chart_tre(_data): void {
    if (_data == null || _data.length == 0) {
      this.chart_tre = null;
      return;
    }
    const pie_labels = [];
    const pie_data = [];
    _data.forEach(element => {
      pie_labels.push(element?.category + " - " + element?.event);
      pie_data.push(element?.count);
    });

    this.chart_tre = {
      datasets: [{
        label: '# of vistas',
        data: pie_data
      }],
      labels: pie_labels,
      options: this.pie_options,
      colors: this.pie_color
    };
  }

  change_filter_group_by_current(): void {
    this.dashboard_home_get_count_view_page();
  }

  dashboard_home_get_count_view_page(): void {
    this.loading = true;
    const filters = {
      group_by: this.filter_group_by_current,
      date_ini: this.filter_period_ini,
      date_end: this.filter_period_end
    };
    this.restService.dashboard_home_get_count_view_page(filters).subscribe(data => {
      if (data.success) {
        const count_view_page = data.data.count_view_page;
        if (count_view_page) {
          this.init_chart_count_view_page(count_view_page);
          this.set_chart_count_view_page();
        }
      }
      this.loading = false;
    }, err => {
      this.loading = false;
    });
  }

  init_chart_count_view_page(_count_view_page) {
    this.count_view_page_labels = [];
    this.count_view_page_dataset_general = {
      label: 'Total',
      data: [],
      borderColor: this.color_general,
      pointBackgroundColor: this.color_general,
      pointBorderColor: this.color_general,
      pointHoverBorderColor: this.color_general,
      pointStyle: 'circle',
      pointRadius: 4,
      pointHoverRadius: 5,
      borderWidth: 2,
      fill: false
    };
    this.count_view_page_dataset_type_frontpage = {
      label: 'Pordada',
      data: [],
      borderColor: this.color_frontpage,
      pointBackgroundColor: this.color_frontpage,
      pointBorderColor: this.color_frontpage,
      pointHoverBorderColor: this.color_frontpage,
      pointStyle: 'circle',
      pointRadius: 4,
      pointHoverRadius: 5,
      borderWidth: 1,
      fill: false
    };
    this.count_view_page_dataset_type_article = {
      label: 'Artículos',
      data: [],
      borderColor: this.color_article,
      pointBackgroundColor: this.color_article,
      pointBorderColor: this.color_article,
      pointHoverBorderColor: this.color_article,
      pointStyle: 'circle',
      pointRadius: 4,
      pointHoverRadius: 5,
      borderWidth: 1,
      fill: false
    };
    this.count_view_page_dataset_type_section = {
      label: 'Secciones',
      data: [],
      borderColor: this.color_section,
      pointBackgroundColor: this.color_section,
      pointBorderColor: this.color_section,
      pointHoverBorderColor: this.color_section,
      pointStyle: 'circle',
      pointRadius: 4,
      pointHoverRadius: 5,
      borderWidth: 1,
      fill: false
    };
    this.count_view_page_dataset_type_topic = {
      label: 'Temas',
      data: [],
      borderColor: this.color_topic,
      pointBackgroundColor: this.color_topic,
      pointBorderColor: this.color_topic,
      pointHoverBorderColor: this.color_topic,
      pointStyle: 'circle',
      pointRadius: 4,
      pointHoverRadius: 5,
      borderWidth: 1,
      fill: false
    };
    this.count_view_page_dataset_type_other = {
      label: 'Otras',
      data: [],
      borderColor: this.color_other,
      pointBackgroundColor: this.color_other,
      pointBorderColor: this.color_other,
      pointHoverBorderColor: this.color_other,
      pointStyle: 'circle',
      pointRadius: 4,
      pointHoverRadius: 5,
      borderWidth: 1,
      fill: false
    };
    _count_view_page.forEach(element => {
      if (element.period || element.period == '0') this.count_view_page_labels.push(element.period);
      if (element.count || element.count == '0') this.count_view_page_dataset_general.data.push(element.count);
      if (element.type_frontpage || element.type_frontpage == '0') this.count_view_page_dataset_type_frontpage.data.push(element.type_frontpage);
      if (element.type_article || element.type_article == '0') this.count_view_page_dataset_type_article.data.push(element.type_article);
      if (element.type_section || element.type_section == '0') this.count_view_page_dataset_type_section.data.push(element.type_section);
      if (element.type_topic || element.type_topic == '0') this.count_view_page_dataset_type_topic.data.push(element.type_topic);
      if (element.type_other || element.type_other == '0') this.count_view_page_dataset_type_other.data.push(element.type_other);
    });

  }

  set_chart_count_view_page() {
    var datasets = [
      this.count_view_page_dataset_general,
      this.count_view_page_dataset_type_frontpage,
      this.count_view_page_dataset_type_article,
      this.count_view_page_dataset_type_section,
      this.count_view_page_dataset_type_topic,
      this.count_view_page_dataset_type_other
    ];
    this.count_view_page = {
      datasets: datasets,
      labels: this.count_view_page_labels,
      options: this.line_options
    };
  }

  onChangeTab1(_data = null) {
    if (_data) {
      if ("Artículos mas vistas" == _data.nextId && !this.top_views_article) this.dashboard_home_get_data_top_views_article();
      if ("Secciones mas vistas" == _data.nextId && !this.top_views_section) this.dashboard_home_get_data_top_views_section();
      if ("Temas mas vistos" == _data.nextId && !this.top_views_topic) this.dashboard_home_get_data_top_views_topic();
      this.LastSectionTab1 = _data.nextId
    } else {
      if ("Artículos mas vistas" == this.LastSectionTab1 && !this.top_views_article) this.dashboard_home_get_data_top_views_article();
      if ("Secciones mas vistas" == this.LastSectionTab1 && !this.top_views_section) this.dashboard_home_get_data_top_views_section();
      if ("Temas mas vistos" == this.LastSectionTab1) this.dashboard_home_get_data_top_views_topic();
    }

  }

  onChangeTab2(_data = null) {
    if (_data) {
      if ("Temas mas vistos - artículo" == this.LastSectionTab2 && !this.top_views_topic_article) this.dashboard_home_get_data_top_views_topic_article();
      if ("Eventos mas realizados" == _data.nextId && !this.top_realized_event) this.dashboard_home_get_data_top_realized_event();
      this.LastSectionTab2
    } else {
      if ("Temas mas vistos - artículo" == this.LastSectionTab2) this.dashboard_home_get_data_top_views_topic_article();
      if ("Eventos mas realizados" == this.LastSectionTab2) this.dashboard_home_get_data_top_realized_event();
    }
  }

  clearTables() {
    this.top_views_page = null;
    this.top_views_article = null;
    this.top_views_section = null;
    this.top_views_topic = null;
    this.top_keyword = null;
    this.top_views_section_article = null;
    this.chart_tvsa = null;
    this.top_views_topic_article = null;
    this.chart_tvta = null;
    this.top_realized_event = null;
    this.chart_tre = null;
  }

}